import {
  createContext,
  useCallback,
  useState,
  useSyncExternalStore,
} from "react";
import API from "services/api";
import _ from "lodash";
import toast from "react-hot-toast";
import moment from "moment";

export const InvoiceReportContext = createContext({});

const InvReportProvider = (props) => {
  const [byfilings, setByFilings] = useState([]);
  const [invprods, setInvProds] = useState([]);
  const [invprodPopulate, setInvProdPopulate] = useState([]);
  const [detailInvProd, setDetailInvProd] = useState({});
  const [detailSOA, setDetailSOA] = useState({});

  const [invSOA, setSOA] = useState([]);

  const getInvbyFiling = (params) => {
    return API.getInvbyFiling(params)
      .then((res) => {
        const { data } = res;
        let newObject = data?.map((row) => {
          // console.log("data content", row.paymentDate);
          return {
            ...row,
            fixedAmount:
              row?.currency === "IDR" ? row?.totalAmount : row?.fixedAmount,
            originalAmount:
              row?.currency === "IDR" ? row?.totalAmount : row?.fixedAmount,
            paymentDate: row.paymentDate !== undefined
              ? moment(row.paymentDate).format("DD MMMM YYYY")
              : '-',
          };
        });

        setByFilings(newObject);
        return newObject;
      })
      .catch((err) => {
        console.log("err", err);
        return err;
      });
  };

  const getInvProd = (params) => {
    return API.getInvProd(params)
      .then((res) => {
        const { data } = res;
        setInvProds(data);
        return data;
      })
      .catch((err) => {
        console.log("err", err);
        return err;
      });
  };

  const getInvProdbyID = (params) => {
    return API.getInvProdbyID(params)
      .then((res) => {
        const { data } = res;
        setDetailInvProd(data);
        return data;
      })
      .catch((err) => {
        console.log("err", err);
        return err;
      });
  };

  const getInvProdGenerated = (params) => {
    return API.getInvProdGenerated(params)
      .then((res) => {
        const { data } = res;
        setInvProdPopulate(data);
        return data;
      })
      .catch((err) => {
        console.log("err", err);
        return err;
      });
  };

  const createInvProd = (data) => {
    return API.createInvProd(data)
      .then((res) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getInvSOA = (params) => {
    return API.getInvSOA(params)
      .then((res) => {
        const { data } = res;
        setSOA(data);
        return data;
      })
      .catch((err) => {
        console.log("err", err);
        return err;
      });
  };

  const getInvSOAbyID = (id) => {
    return API.getInvSOAbyID(id)
      .then((res) => {
        const { data } = res;
        setDetailSOA(data);
        return data;
      })
      .catch((err) => {
        console.log("err", err);
        return err;
      });
  };

  const createInvSOA = (data) => {
    return API.createInvSOA(data)
      .then((res) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };

  const createManyInvSOA = (data) => {
    return API.createManyInvSOA(data)
      .then((res) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };

  return (
    <InvoiceReportContext.Provider
      value={{
        byfilings,
        setByFilings,
        getInvbyFiling,

        getInvProd,
        createInvProd,

        invprods,
        invprodPopulate,
        getInvProdGenerated,

        detailInvProd,
        setDetailInvProd,
        getInvProdbyID,

        invSOA,
        getInvSOA,
        createInvSOA,
        createManyInvSOA,
        detailSOA,
        getInvSOAbyID,
      }}
      {...props}
    />
  );
};

export default InvReportProvider;
